import React from 'react'
import { Geolocation } from '../../domain/models'

export interface IGeolocationContext {
    isLoadingGeolocation: boolean
    geolocation?: Geolocation
    updateGeolocation: () => void
}

export const GeolocationContext = React.createContext<IGeolocationContext>({
    isLoadingGeolocation: true,
    geolocation: undefined,
    updateGeolocation: () => console.warn('updateGeolocation not implemented in the currentContext')
})

export const useGeolocationContext = (): IGeolocationContext => React.useContext(GeolocationContext)
